///<reference path="../require.d.ts"/>

import {CheckedRoomRepository} from "../services/CheckedRoomRepository";

class RoomsDetailCheckController {

    static $inject = ['CheckedRoomRepository'];

    id: number;
    isChecked: boolean;

    constructor(
        private checked: CheckedRoomRepository
    ) {
        const m = /rooms\/(\d+)(\.html)?/.exec(location.pathname);
        this.id = Number(m[1]);
        this.isChecked = this.checked.isChecked(this.id);
    }

    toggle(): void {
        this.checked.toggle(this.id);
    }

}

angular.module('hp').controller('RoomDetailCheckController', RoomsDetailCheckController);



// WEBPACK FOOTER //
// ./controllers/RoomDetailCheckController.ts